/**
 * Main App component with routing and authentication
 */
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { OAuthCallbackPage } from './pages/OAuthCallback';
import { DashboardPage } from './pages/DashboardPage';
import { ClientListPage } from './pages/ClientListPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { BorrowingCalculatorPage } from './pages/BorrowingCalculatorPage';
import { ProposalGeneratorPage } from './pages/ProposalGeneratorPage';
import { ProposalListPage } from './pages/ProposalListPage';
import { PeLpValuationPage } from './pages/PeLpValuationPage';
import { PeCollateralAssessmentPage } from './pages/PeCollateralAssessmentPage';
import { PeFundOverviewPage } from './pages/PeFundOverviewPage';
import { LendingWorkflowPage } from './pages/LendingWorkflowPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { CollateralMonitoringPage } from './pages/CollateralMonitoringPage';
import { ConnectorAttestPage } from './pages/ConnectorAttestPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<OAuthCallbackPage />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/clients" element={<ClientListPage />} />
              <Route path="/clients/:clientId" element={<ClientDetailPage />} />
              <Route path="/calculator" element={<BorrowingCalculatorPage />} />
              <Route path="/proposals" element={<ProposalListPage />} />
              <Route path="/proposals/new" element={<ProposalGeneratorPage />} />
              <Route path="/proposals/:proposalId" element={<ProposalGeneratorPage />} />
              <Route path="/lending/workflows" element={<LendingWorkflowPage />} />
              <Route path="/documents" element={<DocumentsPage />} />
              <Route path="/collateral" element={<CollateralMonitoringPage />} />
              <Route path="/connector" element={<ConnectorAttestPage />} />
              <Route path="/pe/lp-valuation" element={<PeLpValuationPage />} />
              <Route path="/pe/collateral" element={<PeCollateralAssessmentPage />} />
              <Route path="/pe/funds" element={<PeFundOverviewPage />} />
            </Route>
          </Route>

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
